import { CompanyId, DivisionDto, DivisionId, UserCompanyDto } from '../../../services/api.types'

export interface GroupOption {
  divisionId: DivisionId
  companyId: CompanyId
  name: string
  categoryId?: string
}

// Derives the user's group (division) options from their company memberships.
// When companyId is omitted, groups from all companies are returned.
export const deriveGroupOptions = (
  userCompanies: UserCompanyDto[] | undefined,
  divisions: DivisionDto[] | undefined,
  companyId?: CompanyId,
): GroupOption[] => {
  const options: GroupOption[] = []
  if (!userCompanies || !divisions) return options

  const companyUcs = companyId ? userCompanies.filter((uc) => uc.companyId === companyId) : userCompanies

  companyUcs.forEach((uc) => {
    // Legacy single division
    if (uc.divisionId) {
      const div = divisions.find((d) => d.id === uc.divisionId)
      if (div) {
        options.push({
          divisionId: div.id,
          companyId: uc.companyId,
          name: div.name,
          categoryId: div.categoryId,
        })
      }
    }

    // New multi-category system
    if (uc.divisionIds) {
      try {
        const parsed = JSON.parse(uc.divisionIds)
        Object.entries(parsed).forEach(([categoryId, divId]) => {
          if (divId && typeof divId === 'string') {
            // Skip if already added via legacy divisionId
            if (options.some((o) => o.divisionId === divId)) return
            const div = divisions.find((d) => d.id === divId)
            if (div) {
              options.push({
                divisionId: div.id,
                companyId: uc.companyId,
                name: div.name,
                categoryId,
              })
            }
          }
        })
      } catch (e) {
        // Ignore parse errors
      }
    }
  })

  return options
}
